module.exports = __webpack_public_path__ + "static/img/3578_phase_function_Paper_PointsHejduk_Prediction.0d17418.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3578_phase_function_Paper_PointsHejduk_Prediction.png
// module id = jGul
// module chunks = 0